import React from 'react';
import {bindActionCreators} from "redux";
import {connect} from "react-redux";
import {getGameInstance, sendInput} from "game/app/actions/game-instance-actions";
import MainMenu from './main-menu';
import Rules from './rules';
import IntroNode from './nodes/intro-node';
import Round01Node from './nodes/round01-node';
import Round02Node from './nodes/round02-node';
import Round03Node from './nodes/round03-node';
import FinalNode from './nodes/final-node';
import {Route, Switch, withRouter} from "react-router-dom";
import BonusTasksIndex from './bonus-tasks/index';
import GameComponent from "game/app/components/game/game-component";
import {getCreativeTasks} from "game/app/actions/creative-tasks-actions";
import BankruptcyModal from "./events/bankruptcy_modal";
import {loadQuestions} from "game/app/actions/knowledge-questions";
import {setTheme} from "game/app/actions/theme-actions";
import Navbar from "./navbar";
import Background from "../../../background";
import Notifications from "../../../layout/notifications";
import Footer from "../../../layout/footer";

class SecondarySchool extends GameComponent {

    componentWillMount() {
    }

    componentDidMount() {
    }

    componentWillUnmount() {
    }

    render() {
        return (
            <div id='body-container' className={this.props.mainClass}>
                <Navbar/>
                <div className='clearfix'>&nbps;</div>
                <div id='main-container' className='content'>
                    <Background/>
                    <Notifications/>
                    <div id='game-bg'/>
                    <Switch>
                        <Route path='/game/:instance_id/bonus-tasks' component={BonusTasksIndex}/>
                        <Route path='/game/:instance_id/intro' component={IntroNode}/>
                        <Route path='/game/:instance_id/round-1' component={Round01Node}/>
                        <Route path='/game/:instance_id/round-2' component={Round02Node}/>
                        <Route path='/game/:instance_id/round-3' component={Round03Node}/>
                        <Route path='/game/:instance_id/final' component={FinalNode}/>
                        <Route path='/game/:instance_id/rules' component={Rules}/>
                        <Route component={MainMenu}/>
                    </Switch>
                    <BankruptcyModal/>
                </div>
                <Footer/>
            </div>

        )
    }
}

function mapStateToProps(state,ownProps) {
    return {
        gameInstance: state.gameInstance,
        knowledgeQuestions: state.knowledgeQuestions,
        creativeTasks: state.creativeTasks,
        theme: state.theme
    };
}

function matchDispatchToProps(dispatch){
    return bindActionCreators({
        getGameInstance: getGameInstance,
        sendInput: sendInput,
        getCreativeTasks: getCreativeTasks,
        loadQuestions: loadQuestions,
        setTheme: setTheme
    }, dispatch);
}

export default withRouter(connect(mapStateToProps, matchDispatchToProps)(SecondarySchool));
